'use client';

import React from 'react';
import styled from 'styled-components';
import { mediaQuery, typography } from '../../theme';
import { Primary } from '../button';
import { Path } from '../../routes/components/path';

export const NotFoundPage: React.FC = () => (
  <TextContent>
    <StyledHeader>Sivua ei löydy</StyledHeader>
    <StyledParagraph>Kaikkea muuta maukasta kyllä löytyy.</StyledParagraph>
    <ButtonWideInMobile href={Path.Home}>Etusivulle</ButtonWideInMobile>
  </TextContent>
);

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12em 1em;
  width: 100%;

  @media ${mediaQuery.medium} {
    padding: 8em 1em;
  }

  @media ${mediaQuery.small} {
    padding: 6em 1em;
  }
`;

const StyledHeader = styled.h1`
  ${typography.headingLargeStyle}
  font-size: 3.125rem;
  letter-spacing: 0;
  line-height: 100%;
  font-weight: 1000;
  margin-bottom: 20px;
  text-align: center;
`;

const ButtonWideInMobile = styled(Primary)`
  width: auto;

  @media ${mediaQuery.medium} {
    width: 15em;
  }
`;

export const StyledParagraph = styled.p`
  ${typography.textStyle}
  text-align: center;
  margin-bottom: 1.25em;
`;
